module.exports = __webpack_public_path__ + "img/TURNOVER.44625fa0.svg";